import { render, staticRenderFns } from "./RandomWrongAnswers.vue?vue&type=template&id=c17c7f56&scoped=true&"
import script from "./RandomWrongAnswers.vue?vue&type=script&lang=js&"
export * from "./RandomWrongAnswers.vue?vue&type=script&lang=js&"
import style0 from "./RandomWrongAnswers.vue?vue&type=style&index=0&id=c17c7f56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c17c7f56",
  null
  
)

export default component.exports